<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";

    interface Props {
        border?: boolean;
        variant?: "blue-background" | "transparent";
    }
    withDefaults(defineProps<Props>(), {
        border: false,
        variant: "blue-background",
    });

    const fetchKontaktorsak = async ({ query }: { query?: string } = {}) => {
        const store = useStore();

        try {
            const params: { q?: string } = {};

            if (query) {
                params.q = query;
            }

            const { subsetName } = await store.dispatch("operation/kontaktorsak/fetchKontaktorsak", {
                filterParams: params,
                displayMode: true,
            });

            return store.getters["operation/kontaktorsak/kontaktorsakSubset"]({ subsetName, displayMode: true });
        } catch (error) {
            flashWarning("Kunde inte hämta kontaktorsaker");
        }
    };
</script>

<template>
    <KAutocomplete
        name="kontaktorsak"
        label="Kontaktorsak"
        :options="fetchKontaktorsak"
        :converter="defaultAutocompleteConverter"
        :class="[{ 'field-container': border, [variant]: border }]"
        v-bind="$attrs"
    />
</template>

<style lang="scss" scoped>
    @import "@/components/forms/Form/styles/FieldBackgrounds.scss";
    .field-container {
        // Om ingen variant är satt, används inget bakgrundsfärg
        @include field-container-mixin();
    }
</style>
